export enum OverflowBehaviour {
    VISIBLE = "visible",
    SCROLL = "scroll",
    HIDDEN = "hidden"
}
